var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v(_vm._s(_vm.$t("public.whereToStay.find_place_to_stay")))]),_c('iframe',{attrs:{"src":_vm.stay22Url,"id":"stay22-widget","width":"100%","height":"90%","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }